import {
  Component,
  OnInit,
  Input,
  OnChanges,
  SimpleChanges,
  OnDestroy,
} from '@angular/core';

import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from 'src/app/common/services/api.service';
import { map } from 'rxjs/operators';
import { MessageService } from 'src/app/common/services/message.service';
import { CommonService } from 'src/app/common/services/common.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalService } from 'ng-zorro-antd/modal';
import { CHECKED, CROSS_2X } from 'src/defaultImages.js';
@Component({
  selector: 'app-dish-image-upload',
  templateUrl: './dish-image-upload.component.html',
  styleUrls: ['./dish-image-upload.component.css'],
})
export class DishImageUploadComponent implements OnInit, OnChanges, OnDestroy {
  images = {
    CHECKED: CHECKED,
    CROSS_2X: CROSS_2X,
  };
  @Input() data;
  @Input() type;
  @Input() addDishFlow = false;
  @Input() cmmView: boolean;
  @Input() cmmLibrary: boolean = false;
  @Input() imagePaths;
  @Input() maxImageCount = 5;
  @Input() itemData;
  imageArray = [];
  imageArrayReadable = [];
  fileList: File[] = [];
  showBin = true;
  index;
  showUploadList = {
    showPreviewIcon: false,
    showRemoveIcon: false,
    hidePreviewIconInNonImage: true,
  };
  urls = new Array<any>();
  counter: number = 0;
  thumbNail: string = '';
  delete_list: string[] = [];
  thumbNailChanged: boolean = false;
  thumb_type: any = 1;
  curr_bintype: any = 'old';
  messageStruct: any;
  id: any;
  translationText;
  subscription = new Subscription();

  isMenu = false;
  constructor(
    private apiService: ApiService,
    private messageService: MessageService,
    private commonservice: CommonService,
    private _message: NzMessageService,
    private translateService: TranslateService,
    private modalService: NzModalService
  ) {}

  ngOnInit() {
    this.subscription.add(
      this.translateService.get(['SHARED']).subscribe((res) => {
        this.translationText = res.SHARED;
      })
    );
    if (this.type === 1 && !this.cmmLibrary) {
      this.getDishImages(this.itemData);
    }
    this.isMenu = (this.data || {}).type === 'menu' || this.addDishFlow;
    console.log(this.addDishFlow, this.isMenu);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.type === 1 && this.cmmLibrary && this.imagePaths) {
      this.handleCMMDishImages();
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  handleCMMDishImages() {
    this.imageArray = (this.imagePaths || {}).image_path || [];
    this.thumbNail = this.extractImagePath(
      (this.imagePaths || {}).thumb_path || ''
    );
    this.imageArray.forEach((img) => {
      const imageName = this.extractImagePath(img);
      this.imageArrayReadable.push(imageName);
    });
  }

  extractImagePath(path): string {
    const imgArr = path.split('/');
    return imgArr[imgArr.length - 1];
  }

  beforeUpload = (file: File): any => {
    // if (this.type === 1) {
    //   this.uploadDishImage(this.data.dish_id, file);
    //   return false;
    // }
    if (file.size < 5120000) {
      if (
        file.type == 'image/jpeg' ||
        file.type == 'image/jpg' ||
        file.type == 'image/png'
      ) {
        this.fileList.push(file);
        this.convertImageURL(file);
        this.makeThumbNail();
      } else
        this.messageService.showError(
          this.translationText.UNSUPPORTED_IMG_FORMAT
        );
    } else this.messageService.showError(this.translationText.FILE_SIZE_ERROR);
    return false;
  };

  makeThumbNail() {
    if (this.thumbNail == '') this.thumbNail = this.fileList[0].name;
  }

  convertImageURL(file) {
    let reader = new FileReader();
    reader.onload = (e: any) => {
      this.urls.push({
        id: this.counter,
        path: e.target.result,
        name: file.name,
      });
    };
    reader.readAsDataURL(file);
  }

  getDishImages(data: any): void {
    this.imageArray = (data || {}).image_paths || [];
    this.thumbNail = (data || {}).thumb_path || '';
    this.imageArray.forEach((x) => {
      const img = x.split('/');
      const imageName = img[img.length - 1];
      this.imageArrayReadable.push(imageName);
    });
  }

  uploadCMMDishImage(dish_id, files) {
    if (dish_id && (this.data || {}).hq_id) {
      return new Promise((resolve, reject) => {
        const param = new FormData();
        param.append('hq_item_id', dish_id);
        this.cmmLibrary
          ? param.append('hq_id', (this.data || {}).hq_id || '')
          : param.append('rest_id', localStorage.getItem('restaurant_id'));
        for (let i = 0; i < files.length; i++) param.append('files', files[i]);
        // edit dish case
        if (this.type == 1) {
          param.append('delete_list', JSON.stringify(this.delete_list));
          param.append('thumb', this.thumbNail);
          param.append('thumb_type', this.thumb_type);
        }
        // add dish case
        if (this.type == 2) {
          param.append('delete_list', JSON.stringify([]));
          param.append('thumb', this.thumbNail);
          param.append('thumb_type', this.thumb_type);
        }
        if (files.length > 0) {
          this.id = this._message.loading(
            this.translationText.IMAGE_UPLOAD_MSG,
            {
              nzDuration: 0,
            }
          ).messageId;
        }
        this.apiService
          .uploadDishImage(param)
          .pipe(map((res) => res))
          .subscribe(
            (res) => {
              try {
                this._message.remove(this.id);
              } catch (error) {}
              if (
                files.length > 0 ||
                this.delete_list.length > 0 ||
                this.thumbNailChanged
              ) {
                if ((res || {}).statusCode === 201) {
                  this.messageStruct = {
                    data: { item_id: dish_id },
                    topic: 'item_image_updated',
                    message: 'update item image',
                  };
                  this.commonservice.sendMessage(this.messageStruct);
                  if (((res || {}).data || {}).upload_status == 1) {
                    this.messageService.showSuccess(
                      ((res || {}).data || {}).upload_message
                    );
                    // this._message.remove(this.id);
                  } else if (((res || {}).data || {}).upload_status == 0)
                    this.messageService.showError(
                      ((res || {}).data || {}).upload_message
                    );
                  if (((res || {}).data || {}).delete_status == 1)
                    this.messageService.showSuccess(
                      ((res || {}).data || {}).delete_message
                    );
                  else if (((res || {}).data || {}).delete_status == 0)
                    this.messageService.showError(
                      ((res || {}).data || {}).delete_message
                    );
                  if (((res || {}).data || {}).thumb_status == 1)
                    this.messageService.showSuccess(
                      this.translationText.THUMBNAIL_UPDATED
                    );
                  else if (((res || {}).data || {}).thumb_status == 0)
                    this.messageService.showError(
                      ((res || {}).data || {}).thumb_message
                    );
                } else {
                  this._message.remove(this.id);
                  this.messageService.showError(
                    ((res || {}).data || {}).message
                  );
                }
              } else if ((res || {}).statusCode === 201) {
                resolve(this.translationText.IMAGE_UPLOADED);
              }
            },
            (err) => {
              reject('error');
              this._message.remove(this.id);
              this.messageService.showError(
                (err.error || {}).message ||
                  this.translationText.SOME_ERROR_OCCURED
              );
            }
          );
      });
    }
  }

  uploadDishImage(dish_id, files) {
    return new Promise((resolve, reject) => {
      const param = new FormData();
      param.append('item_id', dish_id);
      this.cmmLibrary
        ? param.append('hq_id', (this.data || {}).hq_id || '')
        : param.append('rest_id', localStorage.getItem('restaurant_id'));
      for (let i = 0; i < files.length; i++) param.append('files', files[i]);
      // edit dish case
      if (this.type == 1) {
        param.append('delete_list', JSON.stringify(this.delete_list));
        param.append('thumb', this.thumbNail);
        param.append('thumb_type', this.thumb_type);
      }
      // add dish case
      if (this.type == 2) {
        param.append('delete_list', JSON.stringify([]));
        param.append('thumb', this.thumbNail);
        param.append('thumb_type', this.thumb_type);
      }
      if (files.length > 0) {
        this.id = this._message.loading(this.translationText.IMAGE_UPLOAD_MSG, {
          nzDuration: 0,
        }).messageId;
      }
      this.apiService
        .uploadImage(param)
        .pipe(map((res) => res))
        .subscribe(
          (res) => {
            resolve(this.translationText.IMAGE_UPLOADED);
            try {
              this._message.remove(this.id);
            } catch (error) {}
            if (
              files.length > 0 ||
              this.delete_list.length > 0 ||
              this.thumbNailChanged
            ) {
              if (res.statusCode === 201) {
                this.messageStruct = {
                  data: { item_id: dish_id },
                  topic: 'item_image_updated',
                  message: 'update item image',
                };
                this.commonservice.sendMessage(this.messageStruct);
                if ((res.data || {}).upload_status == 1) {
                  this.messageService.showSuccess(
                    (res.data || {}).upload_message
                  );
                  // this._message.remove(this.id);
                } else if ((res.data || {}).upload_status == 0)
                  this.messageService.showError(
                    (res.data || {}).upload_message
                  );
                if ((res.data || {}).delete_status == 1)
                  this.messageService.showSuccess(
                    (res.data || {}).delete_message
                  );
                else if ((res.data || {}).delete_status == 0)
                  this.messageService.showError(
                    (res.data || {}).delete_message
                  );
                if ((res.data || {}).thumb_status == 1)
                  this.messageService.showSuccess(
                    this.translationText.THUMBNAIL_UPDATED
                  );
                else if ((res.data || {}).thumb_status == 0)
                  this.messageService.showError((res.data || {}).thumb_message);
              } else {
                this._message.remove(this.id);
                this.messageService.showError((res.data || {}).message);
              }
            }
          },
          (err) => {
            reject('error');
            this._message.remove(this.id);
            this.messageService.showError(
              (err.error || {}).message ||
                this.translationText.SOME_ERROR_OCCURED
            );
          }
        );
    });
  }
  deleteDishImage(img_name, i) {
    const img = img_name.split('/');
    const imageName = img[img.length - 1];

    if (
      this.imageArrayReadable[i] === this.thumbNail &&
      this.imageArray.length > 1
    ) {
      this.delete_list.push(imageName);
      this.imageArray.splice(i, 1);
      this.imageArrayReadable.splice(i, 1);
      this.thumbNail = this.imageArrayReadable[0];
    } else if (
      this.imageArrayReadable[i] === this.thumbNail &&
      this.imageArray.length == 1
    ) {
      this.delete_list.push(imageName);
      this.imageArray.splice(i, 1);
      this.imageArrayReadable.splice(i, 1);
      this.thumbNail = '';
    } else {
      this.delete_list.push(imageName);
      this.imageArray.splice(i, 1);
      this.imageArrayReadable.splice(i, 1);
    }
  }

  showDeleteBin(i, type) {
    // this.showBin = true;
    this.index = i;
    this.curr_bintype = type;
  }
  hideBin() {
    // this.showBin = false;
  }
  deleteImage(index) {
    if (
      this.fileList[index].name === this.thumbNail &&
      this.fileList.length > 1
    ) {
      this.fileList.splice(index, 1);
      this.urls.splice(index, 1);
      this.thumbNail = this.fileList[0].name;
    } else if (this.fileList.length == 1) {
      this.fileList.splice(index, 1);
      this.urls.splice(index, 1);
      this.thumbNail = '';
    } else {
      this.fileList.splice(index, 1);
      this.urls.splice(index, 1);
    }
  }

  selectThumbNail(imgPath, type) {
    if (this.cmmView) return;
    if (type == 0) {
      let img = imgPath.split('/');
      this.thumbNail = img[img.length - 1];
      this.thumb_type = 0;
    } else if (type == 1) {
      this.thumbNail = imgPath;
      this.thumb_type = 1;
    }
    this.thumbNailChanged = true;
  }
  isThumbNail(thumbImg, imgPath, type) {
    if (type == 0) {
      let img = imgPath.split('/');
      let x = img[img.length - 1];
      return thumbImg === x;
    } else if (type == 1) {
      return imgPath === this.thumbNail;
    }
  }

  useImageEditor: boolean = true;
  async openImageEditor() {
    let data = {
      aspectRatio: this.isMenu ? 6 / 5 : 4 / 3,
      maxSizeInMB: 5,
      imageDimensions: '522 X 435 px',
    };
    const { ImageEditorComponent } = await import(
      /* webpackPrefetch: true */ 'src/app/common/components/image-editor/image-editor.component'
    );
    const modal = this.modalService.create({
      nzTitle: this.translationText.UPLOAD_DISH_IMAGE,
      nzContent: ImageEditorComponent,
      nzFooter: null,
      nzWidth: 800,
      nzComponentParams: { data },
    });
    modal.afterClose.subscribe(
      (res) =>
        (res || {})['result'] === 'success' && this.beforeUpload(res.file)
    );
  }

  allowImageEditor() {
    return !!(this.useImageEditor && !this.cmmView);
  }
}
